(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('ErrorDialogController', ErrorDialogController);

    ErrorDialogController.$inject = ['$scope', '$uibModalInstance', '$q', '$state', 'isTranslate', 'message', 'title'];

    function ErrorDialogController($scope, $uibModalInstance, $q, $state, isTranslate, message, title) {
        var vm = this;
        vm.message = message;
        vm.title = title;
        vm.isTranslate = isTranslate ? isTranslate : false;

        vm.yes = function () {
            $uibModalInstance.close(true);
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
